/* Task types whose kept pane is shared by more than one caller — kept
 * out of TaskPane.tsx so that file exports components only. */

export const CHASE_PANE_TASK_TYPES = ['investigation_action', 'request_overdue']

export const TAKEOVER_PANE_TASK_TYPES = [
  'document_stuck',
  'dead_letter_review',
  // look_through_incomplete has no take-over verb of its own, but it routed
  // to the generic fallback stub (a dead end). The take-over pane now gives
  // it a real surface: guidance + a deep-link to confirm the target.
  'look_through_incomplete',
]
